/**
 * Updates a value in an array by mutating the original array. If the value
 * exists in the array, it is updated in place. If the value does not exist in
 * the array, it is pushed to the end.
 *
 * @param allValues The array of all values that will be mutated.
 * @param value The value that will be updated in place or pushed to end.
 * @param getId A callback to get the unique identifier for an array value.
 *
 * @example
 * ```
 * updateValueInPlace(users, fred, (user) => user.id);
 * ```
 */
export const updateValueInPlace = <T>(
  allValues: T[],
  value: T,
  getId: (value: T) => string | number,
) => {
  const index = allValues?.findIndex((v) => getId(v) === getId(value)) ?? -1;
  if (index === -1) {
    allValues?.push(value);
  } else {
    allValues?.splice(index, 1, value);
  }
};
